module.exports = __webpack_public_path__ + "static/media/5-web-or-mls-DSC06980.3de85cdb.jpg";